"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelRoomsContainer = exports.TravelersInputs = exports.ChildrenDOBWrapper = exports.ApplyButton = exports.TravelRoomsWrapper = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const use_deep_compare_effect_1 = __importDefault(require("use-deep-compare-effect"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const components_common_dob_input_1 = require("@hotelplan/components.common.dob-input");
const components_common_inputs_1 = require("@hotelplan/components.common.inputs");
const libs_tracking_1 = require("@hotelplan/libs.tracking");
const TravelRooms_utils_1 = require("./TravelRooms.utils");
exports.TravelRoomsWrapper = styled_components_1.default.div(({ theme }) => theme.travelRooms.wrapper);
const ManualTravelersInput = (0, styled_components_1.default)(components_common_inputs_1.NumericInput).attrs({
    type: 'input',
})(({ theme }) => theme.travelRooms.manualTravelersInput);
exports.ApplyButton = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    type: 'button',
    testId: `travelRoomsApplyButton`,
})(({ theme }) => theme.travelRooms.applyButton);
const CloseButton = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    icon: { name: 'close' },
})(({ theme }) => theme.travelRooms.closeButton);
exports.ChildrenDOBWrapper = styled_components_1.default.div(({ theme }) => theme.travelRooms.childrenDOBWrapper);
const TravelersInputs = (props) => {
    const [t] = (0, next_i18next_1.useTranslation)('search');
    const { changeAdultsCount, changeChildrenCount, changeDOB, adults, travellersCount, maxAdultsCount, maxChildrenCount, minAdultsCount, minChildrenCount, childrenDobs, isManual, className, maxRoomsCount, rooms, minRoomsCount, changeCountOfRooms, roomsLabel, configuration: { dobPicker, isIOSDobInputDisabled, focusFirstDOBElement, isSearchForFourRoomsEnabled, isRoomsInputOnBottom, }, } = props;
    const inputRef = (0, react_1.useRef)(null);
    const childrenCount = childrenDobs.length;
    const AdultInput = isManual ? ManualTravelersInput : components_common_inputs_1.NumericInput;
    (0, react_1.useEffect)(() => {
        var _a;
        if (focusFirstDOBElement && !childrenDobs[0]) {
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [focusFirstDOBElement, childrenCount]);
    const areRoomsFull = travellersCount ===
        (isSearchForFourRoomsEnabled
            ? TravelRooms_utils_1.MAX_TRAVELLERS_FOR_FOUR_ROOMS
            : TravelRooms_utils_1.MAX_TRAVELLERS_DEFAULT);
    const isIncrementDisabled = isManual
        ? adults + childrenCount === TravelRooms_utils_1.MAX_TRAVELERS_FOR_ONE_ROOM ||
            travellersCount ===
                (isSearchForFourRoomsEnabled
                    ? TravelRooms_utils_1.MAX_TRAVELLERS_FOR_FOUR_ROOMS
                    : TravelRooms_utils_1.MAX_TRAVELLERS_DEFAULT)
        : areRoomsFull;
    const isChildrenIncrementDisabled = isManual
        ? TravelRooms_utils_1.MAX_TRAVELERS_FOR_ONE_ROOM - adults === childrenCount || areRoomsFull
        : childrenCount === adults * (TravelRooms_utils_1.MAX_TRAVELERS_FOR_ONE_ROOM - 1) ||
            areRoomsFull;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(AdultInput, { testId: "adults", minValue: minAdultsCount, maxValue: maxAdultsCount, value: adults, incrementDisabled: isIncrementDisabled, label: t('rooms.adults.label'), onChange: changeAdultsCount, className: "adults" }),
        react_1.default.createElement(components_common_inputs_1.NumericInput, { testId: "children", minValue: minChildrenCount, maxValue: maxChildrenCount, value: childrenCount, incrementDisabled: isChildrenIncrementDisabled, label: t('rooms.children.label'), onChange: changeChildrenCount, className: "children" }),
        react_1.default.createElement("div", { className: "children-DOB-Wrapper" }, childrenDobs.map((childDob, i) => (react_1.default.createElement(exports.ChildrenDOBWrapper, { key: i },
            react_1.default.createElement("span", { className: "childrenBirthTitle" },
                t('rooms.children.dateBirth'),
                " ",
                i + 1),
            react_1.default.createElement("div", { className: "childrenBirthInput", "data-id": `dateOfBirthChild-${i + 1}` },
                react_1.default.createElement(components_common_dob_input_1.DOBInput, { value: childDob || '', placeholder: t('DD/MM/YYYY'), onChange: changeDOB(i), onBlur: changeDOB(i), maxAge: TravelRooms_utils_1.MAX_CHILD_AGE, invalid: !(0, TravelRooms_utils_1.validateChildDob)(childDob), hideLabel: true, actionButton: dobPicker, isIOSDobInputDisabled: isIOSDobInputDisabled, inputRef: i === 0 ? inputRef : null })))))),
        isRoomsInputOnBottom ? (react_1.default.createElement(components_common_inputs_1.NumericInput, { testId: "rooms", minValue: minRoomsCount, maxValue: maxRoomsCount, value: rooms, label: roomsLabel, onChange: changeCountOfRooms })) : null));
};
exports.TravelersInputs = TravelersInputs;
const TravelRoomsContainer = (props) => {
    const [t] = (0, next_i18next_1.useTranslation)(['search', 'forms']);
    const { saveTravelRooms, closeTravelRooms, configuration, children, state, changeCountOfRooms, roomsLabel, } = props;
    const { rooms, maxRoomsCount, minRoomsCount } = state;
    (0, use_deep_compare_effect_1.default)(() => {
        if (configuration.hasApplyBtn && !configuration.forceSaveOnEveryChange)
            return;
        if (saveTravelRooms)
            saveTravelRooms(state);
    }, [state]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        configuration.hasCloseBtn ? (react_1.default.createElement(CloseButton, { onClick: closeTravelRooms })) : null,
        react_1.default.createElement(exports.TravelRoomsWrapper, null,
            rooms !== 0 && !(configuration === null || configuration === void 0 ? void 0 : configuration.isRoomsInputOnBottom) ? (
            // NOTE: If 'rooms' is equal to 0 means that we don't need to choose rooms count, just select travellers.
            react_1.default.createElement(components_common_inputs_1.NumericInput, { testId: "rooms", minValue: minRoomsCount, maxValue: maxRoomsCount, value: rooms, label: roomsLabel, onChange: changeCountOfRooms })) : null,
            children),
        configuration.hasApplyBtn && (react_1.default.createElement(exports.ApplyButton, { disabled: !(0, TravelRooms_utils_1.isTravelRoomsValid)(state, configuration.isSearchForFourRoomsEnabled) || (0, TravelRooms_utils_1.hasTravelRoomsEmptyDates)(state), onClick: () => {
                (0, libs_tracking_1.trackTravelRooms)({
                    type: libs_tracking_1.TravelRoomsEventType.TRAVEL_ROOMS_APPLY,
                    payload: {
                        adults: state.adults,
                        children: state.childrenDobs,
                        rooms: state.rooms,
                        source: configuration.isTrackSource && libs_tracking_1.TravelApplySourceType.BUTTON,
                    },
                });
                if (saveTravelRooms)
                    saveTravelRooms(state);
                configuration.forceApplyOnOverlay && closeTravelRooms();
            } }, t('forms:apply.button')))));
};
exports.TravelRoomsContainer = TravelRoomsContainer;
//# sourceMappingURL=TravelersInputs.js.map